import React from 'react';
import Fields from './Fields'
import { Row, Col, Button, Glyphicon } from 'react-bootstrap'

class Item extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false
		}
	}

	toggle = () => {
		this.setState(
			{ expanded: !this.state.expanded }
		);
	}

	render() {
		const item = this.props.item;

		return (
			<React.Fragment>
				<Row>
					<Col md={3}>
						<Button bsStyle="link" className="log-toggle" onClick={this.toggle}>
							<Glyphicon glyph={this.state.expanded ? "chevron-down" : "chevron-right" } />
							<span className="log" style={{ marginLeft: '5px' }}>{item.date}</span>
						</Button>
					</Col>
					<Col md={1}>
						<span className="log">{item.level}</span>
					</Col>
					<Col md={8}>
						<span className="log">{item.message}</span>
					</Col>
				</Row>
				{this.state.expanded &&
					<Fields fields={item.fields} />
				}
				<hr />
			</React.Fragment>)
	}
}

export default Item;



// WEBPACK FOOTER //
// ./src/areas/admin/console/logs/Item.js